import { render } from "./RouteView.vue?vue&type=template&id=4ed9d9da"
const script = {}

import exportComponent from "/Volumes/my/猫嗅笔记相关项目/猫嗅笔记管理后台/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__